var styles = {
  "Container": "_Container_1ymq9_1"
};

export { styles as default };
